import Link from 'next/link';
import { NewTabWhiteImage } from '../../svgImages/NewTabImage';
import { PlusWhiteImage } from '../../svgImages/PlusImage';
import type { ButtonLinkProps } from '../types';

export const ButtonLinkPrimary: React.FC<
  ButtonLinkProps & {
    prefixIcon?: 'plus' | 'newTab';
  }
> = ({ text, href, width, prefixIcon = null, ...attr }) => (
  <Link
    {...attr}
    href={href}
    passHref
    className={
      width === 'fit'
        ? 'group relative flex min-h-10 w-fit items-center justify-center rounded-2 p-3'
        : 'group relative flex min-h-10 w-full items-center justify-center rounded-2 p-3'
    }
  >
    <div className="absolute inset-0 rounded-2 bg-accent-primary transition-[filter] hover:brightness-110" />
    <div className="relative flex w-fit items-center gap-1">
      {prefixIcon === 'plus' && <PlusWhiteImage alt="" className="size-4" />}
      {prefixIcon === 'newTab' && (
        <NewTabWhiteImage alt="" className="size-4" />
      )}
      <div className="cst-button-label-text text-base-100">{text}</div>
    </div>
  </Link>
);
